<span #box (focus)="focused = true" (blur)="focused = false" class="b2a-checkbox" [ngClass]="{'checked': checked, 'disabled': disabled, 'readonly': readonly}" (click)="toggle()" role="checkbox" attr.aria-checked="{{checked}}" tabindex="0">
    <ng-content></ng-content>
</span>



// WEBPACK FOOTER //
// /codebuild/output/src1521087412/src/client/web-client/src/app/theme/components/checkbox/checkbox.component.html